module.exports = __webpack_public_path__ + "img/03.f447cb3e.png";